import { Component } from '@angular/core';

@Component({
	selector: 'sm-backend-layout',
	template: require('./sm-backend-layout.component.html')
})
export class SmBackendLayoutComponent { }


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-backend-layout.component.ts